import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/iphone.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-1cea211b")

_pushScopeId("data-v-1cea211b")
const _hoisted_1 = { class: "banner gradient-3 flex justify-between flex-col flex-grow sm:mx-10 sm:mt-10 sm:bg-center" }
const _hoisted_2 = { class: "background-dotted-pattern w-full h-full flex items-center relative" }
const _hoisted_3 = { class: "px-10 lg:px-20 flex flex-col text-center lg:text-left items-center lg:items-start w-full" }
const _hoisted_4 = /*#__PURE__*/_createVNode("h1", {
  "data-testid": "title",
  class: "text-4xl lg:text-5xl w-full max-w-xl xl:max-w-2xl font-bold leading-11"
}, " Como conhecer melhor a Bíblia? ", -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("p", {
  "data-testid": "description-title",
  class: "text-white w-full max-w-xl md:w-9/12 text-lg font-normal mt-7 m:leading-8"
}, " Memorize textos, referências e eventos bíblicos que irão abençoar profundamente a sua vida. ", -1)
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Aprenda mais sobre a Bíblia! ")
const _hoisted_7 = /*#__PURE__*/_createVNode("img", {
  class: "mockup absolute hidden lg:block",
  src: _imports_0,
  alt: "iphone mockup"
}, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_logo = _resolveComponent("logo")
  const _component_orange_button = _resolveComponent("orange-button")

  return (_openBlock(), _createBlock("section", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode(_component_logo, { class: "block sm:hidden mb-10 px-10" }),
        _hoisted_4,
        _hoisted_5,
        _createVNode(_component_orange_button, {
          class: "mt-10",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.goto('challenges')))
        }, {
          default: _withId(() => [
            _hoisted_6
          ]),
          _: 1
        })
      ]),
      _hoisted_7
    ])
  ]))
})